<template>
  <div style="display: flex; flex-direction: column; align-items: center">
    <el-row style="margin-top: 50px">
      <el-button class="buttonStyle" @click="jg" style="background-color: rgb(247, 206, 70)">加工生产看板</el-button>
      <div class="buttonStyle" style="margin-left:40px;"></div>
    </el-row>
    <el-row style="margin-top: 50px">
      <el-button class="buttonStyle" @click="tz" style="background-color: rgb(152, 30, 245)">涂装生产看板</el-button>
      <div class="buttonStyle" style="margin-left:40px;"></div>
    </el-row>
    <el-row style="margin-top: 50px">
      <el-button class="buttonStyle" @click="dialogLineVisible = true" style="background-color: rgb(163, 214, 79)">组立产线看板</el-button>
      <el-button class="buttonStyle" @click="dialogWjVisible = true" style="margin-left:40px;background-color: rgb(0, 140, 255)">组立物件看板</el-button>
    </el-row>
    <el-row style="margin-top: 50px">
      <el-button class="buttonStyle" @click="zz" style="background-color: #177dd0">制造看板</el-button>
      <div class="buttonStyle" style="margin-left:40px;"></div>
    </el-row>
  </div>
  <el-dialog v-model="dialogLineVisible" title="组立产线看板" width="500" style="height: 200px">
    <div style="display: flex; flex-direction: column; align-items: center">
      <el-select v-model="zl_line_id" @change="zl_line" :clearable="false" placeholder="物件名称" style="margin: auto;width: 250px">
        <el-option
            v-for="item in wuJianNames"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-button @click="zl_line" type="primary" style="margin-top: 30px">跳转</el-button>
    </div>
  </el-dialog>
  <el-dialog v-model="dialogWjVisible" title="组立物件看板" width="500" style="height: 200px">
    <div style="display: flex; flex-direction: column; align-items: center">
      <el-select v-model="zl_wj_id" @change="zl_wj" :clearable="false" placeholder="物件名称" style="margin: auto;width: 250px">
        <el-option
            v-for="item in wuJianNames"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-button @click="zl_wj" type="primary" style="margin-top: 30px">跳转</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "LargeScreen",
  props: {
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data(){
    return{
      wuJianNames:[],
      zl_line_id:'',
      zl_line_url: process.env.VUE_APP_BOARD_URL+"/#/ZL/",
      dialogLineVisible:false,
      zl_wj_id:'',
      zl_wj_url: process.env.VUE_APP_BOARD_URL+"/#/ZL_WJ/",
      dialogWjVisible:false,
    }
  },
  methods:{
    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('bus/datasource/getWuJianInFo');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.wuJianNames = res.data;
    },
    tz(){
      window.open(process.env.VUE_APP_BOARD_URL+"/#/TZ")
      this.setting.$fn.closeWindow();
    },
    jg(){
      window.open(process.env.VUE_APP_BOARD_URL+"/#/processProductionKanBan")
      this.setting.$fn.closeWindow();
    },
    zz(){
      window.open(process.env.VUE_APP_BOARD_URL+"/#/zhiZaoKanBan")
      this.setting.$fn.closeWindow();
    },
    zl_line(){
      if (!this.zl_line_id) {
        return this.$message.error('请先选择物件名称')
      }
      window.open(this.zl_line_url + this.zl_line_id, "_blank")
      this.setting.$fn.closeWindow();
    },
    zl_wj(){
      if (!this.zl_wj_id) {
        return this.$message.error('请先选择物件名称')
      }
      window.open(this.zl_wj_url + this.zl_wj_id, "_blank")
      this.setting.$fn.closeWindow();
    }
  },
  created() {
    this.getWuJianInFo()
  }
}
</script>

<style scoped>
.buttonStyle{
  width: 300px;
  height: 80px;
  color: #FFFFFF;
  font-size: 40px;
  border-radius: 15px;
}

</style>